import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import type { ISidebarNav } from '../helpers/types';

export const useIsSidebarActive = () => {
  const location = useLocation();

  const isSidebarActive = useCallback(
    (sidebarItem: ISidebarNav) => {
      if (location.pathname === '/') {
        return false;
      } else if (sidebarItem.children !== undefined) {
        return Object.values(sidebarItem.children).reduce((accumulator, childSidebarItem) => {
          return accumulator || location.pathname === childSidebarItem.link;
        }, false);
      } else {
        return location.pathname === sidebarItem.link;
      }
    },
    [location.pathname],
  );

  const isChildActive = useCallback(
    (childSidebarItem: ISidebarNav) => {
      if (location.pathname === '/') {
        return false;
      } else {
        return location.pathname === childSidebarItem.link;
      }
    },
    [location.pathname],
  );

  return { isSidebarActive, isChildActive };
};
